module.exports = __webpack_public_path__ + "img/complete.0d8fb911.svg";